<template>
    <el-select
        style="width: 100%"
        value-key="id"
        v-model="locValue"
        filterable
        auto-complete="nope"
        @change="updateInput()"
        size="small">
        <el-option
                v-for="item in statuses"
                :key="item"
                :label="item"
                :value="item">
        </el-option>
    </el-select>
</template>

<script>
export default {
    name: 'StatusFilter',
    props: {
        value: ""
    },
    mounted() {
        this.locValue = this.value
    },
    data: function() {
        return {
            locValue: {},
            statuses: [
                "All", "Active", "Inactive"
            ]
        }
    },
    methods: {
        updateInput() {
            this.$emit('input', this.locValue)
            this.$emit('change', this.locValue)
        }
    },
    watch: {
        value: function(val) {
            this.locValue = val
        }
    }
}
</script>